/**
 * AllMessages created by johnmc on 05/11/17.
 */
import { Component, Input, OnInit } from '@angular/core';

import { AppComponent } from '../app.component';
import { SubMenuOption } from '../types/submenu-option';

@Component({
  selector: 'new-message-page',
  template: `<sub-menu [options]="subMenu"></sub-menu>
    <new-message (message_sent)="onMessageSent($event)"></new-message>
    <div class="warn" *ngIf="!!helpfulMessage">{{helpfulMessage}}</div>
`,
  styles: [
    '.warn { color: #ff4081; font-size: 5em}'
  ]
})

export class NewMessagePageComponent implements OnInit {
  @Input()
  helpfulMessage: string;
  subMenu: SubMenuOption[];

  constructor() {
    this.subMenu = [
      {route: '/messages', title: 'Messages'},
      {route: '/newmessage', title: 'New Message'},
    ];
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    AppComponent.SetTitle('Send New Message');
  }

  onMessageSent(sent: boolean): void {
    if (sent) {
      this.helpfulMessage = `Message has been sent.`;
    } else {
      this.helpfulMessage = `The message was not sent.`;
    }
  }

}
